import React from "react";

/** Centralised input styles (min 48px touch target, WCAG-friendly focus ring). */
export const inputCls =
  "w-full min-h-[48px] px-3.5 py-2.5 bg-white border border-slate-300 rounded-lg text-slate-900 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-teal-600 focus:border-teal-600 transition-colors";

export const labelCls =
  "block text-xs font-semibold uppercase tracking-wider text-slate-600 mb-1.5";

export function Field({ label, children, error }) {
  return (
    <label className="block">
      <span className={labelCls}>{label}</span>
      {children}
      {error && <span className="mt-1 block text-xs font-medium text-rose-600">{error}</span>}
    </label>
  );
}

export function TextInput({ testid, ...props }) {
  return <input data-testid={testid} className={inputCls} {...props} />;
}

export function SelectInput({ testid, children, ...props }) {
  return (
    <select data-testid={testid} className={inputCls} {...props}>
      {children}
    </select>
  );
}
